import { RenameFolderModal } from 'components/WorkspaceFolders/RenameFolderModal';
import { useModal } from 'components/Modal/hooks/useModal';

export const useRenameFolderModal = () => useModal(RenameFolderModal);